import CryptoJS from "crypto-js";
const secretPass = "XkhZG4fW2t2W";

export const EncryptFunction = (text) => {
    const encrypted = CryptoJS.AES.encrypt(text?.toString(), secretPass).toString();
    return encodeURIComponent(encrypted);
};

export const DecryptFunction = (text) => {
    let decrypted;
    try {
        decrypted = CryptoJS.AES.decrypt(decodeURIComponent(text), secretPass);
    } catch(e) {
        console.error(e); // logs URIError: URI malformed
    }
    return decrypted?.toString(CryptoJS.enc.Utf8);
};
const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_AES_KEY);
const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_AES_IV);

// Encrypt
export const EncryptSecretFunction = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, key, { iv: iv });
  return encrypted.toString(); // Base64 string
};

// Decrypt
export const DecryptSecretFunction = (cipherText) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error("Decryption failed:", e);
    return "";
  }
};
export const EncryptObjectFunction = (object) => {
    const text = JSON.stringify(object);
    const encrypted = CryptoJS.AES.encrypt(text?.toString(), secretPass).toString();
    return encodeURIComponent(encrypted);
};

export const DecryptObjectFunction = (text) => {
    let decrypted;
    try {
        decrypted = CryptoJS.AES.decrypt(decodeURIComponent(text), secretPass);
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        if (decryptedText) {
            return JSON.parse(decryptedText);
        } else {
            console.warn("Decryption returned empty or invalid text.");
            return null; 
        }
    } catch (e) {
        console.error("Error during decryption or JSON parsing:", e);
        return null; 
    }
};

